import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function UpdateArticle({ showMessage, id, setShowUpdate }) {
  const navigate = useNavigate();

  const [article, setArticle] = useState(null);
  const [issueId, setIssueId] = useState("");
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [authors, setAuthors] = useState("");
  const [keywords, setKeywords] = useState("");
  const [abstractText, setAbstractText] = useState("");
  const [file, setFile] = useState(null);
  const [issues, setIssues] = useState([]);

  const fileRef = useRef(null);

  const articleTypes = [
    { label: "Original Article", value: "original article" },
    { label: "Review", value: "review" },
    { label: "Case Report", value: "case report" },
    { label: "Letter to the Editor", value: "letter to the editor" },
    { label: "Commentary", value: "commentary" },
    { label: "Book Review", value: "book review" },
    { label: "Professional Paper", value: "professional paper" },
    { label: "Editorial", value: "editorial" },
    { label: "Conference Paper", value: "conference paper" }
  ];

  useEffect(() => {
    fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getArticleById&id=${id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const a = data.article;
          setArticle(a);
          setIssueId(a.issue_id);
          setType(a.type);
          setTitle(a.title);
          setAuthors(a.authors);
          setKeywords(a.keywords);
          setAbstractText(a.abstract);
        } else {
          showMessage("error", "Failed to load article.");
        }
      })
      .catch(err => {
        console.error("Fetch error:", err);
        showMessage("error", "Error loading article.");
      });
  }, [id]);

  useEffect(() => {
    fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
      method: 'GET',
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.success !== 'true') {
          navigate("/dashboard/login");
        }
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    async function fetchIssues() {
      try {
        const res = await fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues');
        const data = await res.json();
        if (data.success) {
          setIssues(data.issues);
        }
      } catch (error) {
        console.error('Failed to fetch issues:', error);
      }
    }

    fetchIssues();
  }, []);

  const updateArticle = async () => {
    const hasChanged =
      issueId !== article.issue_id ||
      type !== article.type ||
      title !== article.title ||
      authors !== article.authors ||
      keywords !== article.keywords ||
      abstractText !== article.abstract ||
      file;

    if (!hasChanged) {
      showMessage("info", "Nothing has changed.");
      return;
    }

    const formData = new FormData();
    formData.append("id", id);
    formData.append("issue_id", issueId);
    formData.append("type", type);
    formData.append("title", title);
    formData.append("authors", authors);
    formData.append("keywords", keywords);
    formData.append("abstract", abstractText);
    if (file) formData.append("file", file);

    try {
      const response = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=updateArticle", {
        method: "POST",
        credentials: "include",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        showMessage("success", "Article updated successfully.");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        showMessage("error", data.error || "Update failed.");
      }
    } catch (err) {
      console.error("Update error:", err);
      showMessage("error", "An error occurred during update.");
    }
  };

  const cancelUpdate = () => {
    setShowUpdate(false);
  };

  return (
    <div className="dash_update_records">
      <label>1. Issue</label><br />
      <select className="dash_input select_dash" value={issueId} onChange={(e) => setIssueId(e.target.value)}>
        <option value="">Select Issue</option>
        {issues.map(issue => (
          <option key={issue.id} value={issue.id}>
            {issue.title}
          </option>
        ))}
      </select><br />

      <label>2. Type</label><br />
      <select className="dash_input select_dash" value={type} onChange={(e) => setType(e.target.value)}>
        <option value="">Select Type</option>
        {articleTypes.map(t => (
          <option key={t.value} value={t.value}>
            {t.label}
          </option>
        ))}
      </select><br />

      <label>3. Title</label><br />
      <input className="dash_input" type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br />

      <label>4. Authors (comma-separated)</label><br />
      <input className="dash_input" type="text" value={authors} onChange={(e) => setAuthors(e.target.value)} /><br />

      <label>5. Keywords (comma-separated)</label><br />
      <input className="dash_input" type="text" value={keywords} onChange={(e) => setKeywords(e.target.value)} /><br />

      <label>6. Abstract</label><br />
      <textarea className="dash_input" value={abstractText} onChange={(e) => setAbstractText(e.target.value)} /><br />

      <label>7. Upload New PDF (optional)</label><br />
      <input ref={fileRef} className="dash_file_upload" type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files[0])} /><br /><br />

      <div className="dash_buttons_wrapper">
        <button className="dash_form_buttom" onClick={updateArticle}>Update</button>
        <button className="dash_form_buttom dash_reset" onClick={cancelUpdate}>Cancel</button>
      </div>
    </div>
  );
}

export default UpdateArticle;
